export function only(fields: ReadonlySet<string>, operation: object): boolean {
  return Object.keys(operation).every((key) => fields.has(key))
}

export function given<T>(next: T | undefined, current: T): T {
  return next === undefined ? current : next
}

export function decimal(
  next: number | string | null | undefined,
  current: string | null,
): string | null {
  if (next === undefined) return current
  return next === null ? null : String(next)
}
